import BaseApiAction from '@Actions/base-api-action';
import { Actions } from '@Context/common/general/context';

export default class GetProgressionConfig extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'progression-temp-getProgressionConfig',
      payload: { ...this._payload },
    });
  }

  onSuccess(data) {
    super.onSuccess(data);
    this._dispatch({
      type: Actions.CoreActions.UpdateState,
      payload: {
        user: {
          progressionConfig: data,
        }
      },
    })
  }
}
